import React, { memo } from 'react';

import { GridCheckbox } from '../helpers/GridCheckbox';

const CheckboxCellRendererComponent = ({ data }) => {
  if (!data) return <span />;

  return <GridCheckbox defaultChecked={data.selected} />;
};

export const CheckboxCellRenderer = memo(CheckboxCellRendererComponent);
